export default [
  {
    ID: 3,
    url: "https://sista-test.ir/",
    status: "در حال انتظار",
    active: false,
    script_ID: "PDmp7j6NGY_vdJpbLQy8w_ajGOgYpLYm",
    created_at: "۱۰:۲۱:۰۳ ۱۴۰۱/۰۶/۰۲",
  },
  {
    ID: 2,
    url: "https://barikell-test.ir/",
    status: "رد شده",
    active: false,
    message: "سایت به دلیل responsive نبودن رد شده است.",
    script_ID: "PDmp7o9NGY_vdJpbMNy8w_ajGOgYpLYm",
    created_at: "۰۹:۱۰:۲۴ ۱۴۰۱/۰۴/۳۱",
  },
  {
    ID: 1,
    url: "https://batmatic-test.ir",
    status: "تایید شده",
    active: true,
    script_ID: "PDmp7j6NGY_vdJpbMNy8w_ajGOgYpLYm",
    created_at: "۰۸:۴۱:۴۴ ۱۴۰۱/۰۴/۲۲",
  },
];
